import IShop from "../entities/IShop";
import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

const getShops = () => {
  return Axios.get<Array<IShop>>(ENDPOINTS.shops.all);
};

type ShopFilterParams = {
  page?: number;
  size?: number;
  [key: string]: any;
};

const filterShops = (params: ShopFilterParams = {}) => {
  const { page = 0, size = 20, ...rest } = params;
  return Axios.get<any>(ENDPOINTS.shops.filter, {
    params: { page, size, ...rest },
  });
};

const createShop = (data: IShop) => {
  return Axios.post<IShop>(ENDPOINTS.shops.create, data);
};

const updateShop = (id: number, data: IShop) => {
  return Axios.put<IShop>(ENDPOINTS.shops.update(id), data);
};

const deleteShop = (id: number) => {
  return Axios.delete(ENDPOINTS.shops.delete(id));
};

const getShopById = (id: number) => {
  return Axios.get<IShop>(ENDPOINTS.shops.byId(id));
};

const getShopsByCustomerId = (customerId: number) => {
  return Axios.get<Array<IShop>>(ENDPOINTS.shops.byCustomerId(customerId));
};

const ShopService = {
  getShops,
  filterShops,
  createShop,
  updateShop,
  deleteShop,
  getShopById,
  getShopsByCustomerId,
};

export default ShopService;
